export const INK = "#141412", INDIGO = "#5856D6", LINK = "#4A4AC2", SUB = "#6C6C69", FAINT = "#9B9B97", MUTE = "#9B9B97", HEADFAINT = "#6E6E6B", HAIR = "#E9E9EC", PANEL = "#FBFBFD", AMBER = "#9A5A00", SOFT = "#F1F1F4";

export const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const ymd = (dt) => `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
export const addDays = (dt, n) => { const d = new Date(dt); d.setDate(d.getDate() + n); return d; };
export const parseYmd = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };
export const fmtYmd = (s) => { const [, m, d] = s.split("-").map(Number); return `${MON[m - 1]} ${d}`; };

export const PRESETS = [["today", "Today", 0], ["d2", "Last 2 days", 1], ["d7", "Last 7 days", 6], ["d30", "Last 30 days", 29]];

// range: { kind: "preset", key } | { kind: "custom", from, to } | { kind: "before", to }
export function rangeDos(range) {
  if (range.kind === "preset") {
    const days = PRESETS.find((p) => p[0] === range.key)[2];
    const t = new Date();
    return { dos_from: ymd(addDays(t, -days)), dos_to: ymd(t) };
  }
  if (range.kind === "custom") return { dos_from: range.from, dos_to: range.to };
  return { dos_to: range.to };
}
// Part F — basis-neutral bounds (used for the Date-added filter, compared against created_at).
export function rangeFromTo(range) {
  const d = rangeDos(range);
  return { from: d.dos_from, to: d.dos_to };
}
export function rangeLabel(range) {
  if (range.kind === "preset") return PRESETS.find((p) => p[0] === range.key)[1];
  if (range.kind === "custom") return range.from === range.to ? fmtYmd(range.from) : `${fmtYmd(range.from)} – ${fmtYmd(range.to)}`;
  return `Before ${fmtYmd(ymd(addDays(parseYmd(range.to), 1)))}`;
}

const QS_LABEL = { visit_id: "Visit ID", icd: "ICD-10", cpt: "CPT", mrn: "MRN", patient: "Patient" };
// Map quick-search text to one search field; `ok` false below its minimum length.
export function mapSearch(text) {
  const t = text.trim();
  if (!t) return null;
  let key, ok;
  if (/^VIS-/i.test(t)) { key = "visit_id"; ok = t.length >= 8; }
  else if (/^[A-Za-z]\d\S*$/.test(t)) { key = "icd"; ok = t.length >= 3; }
  else if (/^\d+$/.test(t)) { key = "cpt"; ok = t.length >= 3; }
  else if (/^\S+$/.test(t) && /\d/.test(t) && t.includes("-")) { key = "mrn"; ok = t.length >= 3; }
  else { key = "patient"; ok = t.split(/\s+/).every((w) => w.length >= 3); }
  const value = key === "icd" || key === "visit_id" ? t.toUpperCase() : t;
  return { key, label: QS_LABEL[key], ok, field: ok ? { [key]: value } : null };
}

export const ADV_FIELDS = [
  ["patient", "Patient", "First or last name"], ["mrn", "MRN", "e.g. NTC-0001"], ["dob", "Date of birth", "MM/DD/YYYY"],
  ["visit_id", "Visit ID", "VIS-…"], ["cpt", "CPT", "e.g. 9921"], ["icd", "ICD-10", "e.g. E11"],
];
export function advErrors(q) {
  const e = {};
  if (q.patient?.trim() && q.patient.trim().split(/\s+/).some((w) => w.length < 3)) e.patient = "Each word needs 3+ letters";
  if (q.mrn?.trim() && q.mrn.trim().length < 3) e.mrn = "3+ characters";
  if (q.dob?.trim() && !/^\d{2}\/\d{2}\/\d{4}$/.test(q.dob.trim())) e.dob = "Use MM/DD/YYYY";
  if (q.visit_id?.trim() && !/^VIS-\S{4,}$/i.test(q.visit_id.trim())) e.visit_id = "VIS- plus 4+ characters";
  return e;
}

export const GROUPS = [["none", "None"], ["physician", "Physician"], ["billing", "Billing provider"], ["patient", "Patient"], ["source", "Source"]];
export const CLAIM_ST = [["processing", "Coding"], ["ready", "Ready"], ["queued", "Claim queued"], ["generated", "Claim generated"]];

export const billingDiffers = (br) => br?.status === "matched" && br.billing_id && br.billing_id !== br.rendering_id;

// Pass A §1 — one search field → exactly one of patient / mrn / dob / visit_id.
export const QF = {
  patient: ["Patient name", "Each word 3+ letters"],
  mrn: ["MRN", "3+ characters"],
  dob: ["Date of birth", "MM/DD/YYYY"],
  visit_id: ["Visit ID", "VIS- plus 4+ characters"],
};
export const detectKey = (t) => (/^VIS/i.test(t) ? "visit_id" : /^\d{1,2}\//.test(t) || /^\d{4}-\d{1,2}/.test(t) ? "dob" : /\d/.test(t) ? "mrn" : "patient");
const READY = {
  visit_id: (t) => /^VIS-[A-Za-z0-9]{4,}/i.test(t),
  dob: (t) => /^\d{2}\/\d{2}\/\d{4}$/.test(t) || /^\d{4}-\d{2}-\d{2}$/.test(t),
  mrn: (t) => t.replace(/[-\s]/g, "").length >= 3,
  patient: (t) => t.split(/\s+/).every((w) => w.length >= 3),
};
export function quickSearch(text, forced) {
  const t = String(text || "").trim();
  if (!t) return null;
  const detected = detectKey(t), key = forced || detected, ok = READY[key](t);
  return { key, detected, ok, label: QF[key][0], rule: QF[key][1], field: ok ? { [key]: key === "visit_id" ? t.toUpperCase() : t } : null };
}
